import { DefaultSections, startPresentation } from "@presentation/Types";
import { Map } from "./Types/Map";

import Introduction from "./Slides/IntroAndOutro/Introduction.vue";
import LeadType from "./Slides/LeadType/LeadType.vue";
import Interest from "./Slides/Interest/Interest.vue";
import InterestTimeline from "./Slides/InterestTimeline/InterestTimeline.vue";
import SelectDojo from "./Slides/SelectDojo/SelectDojo.vue";
import Offer from "./Slides/Offer/Offer.vue";
import Greeting from "./Slides/Greeting/Greeting.vue";
import OfferInformationEmail from "./Slides/OfferInformationEmail/OfferInformationEmail.vue";
import FamilyTraining from "./Slides/FamilyTraining/FamilyTraining.vue";
import HowCanWeHelp from "./Slides/HowCanWeHelp/HowCanWeHelp.vue";
import Close from "./Slides/Close/Close.vue";
import YourGoals from "./Slides/HowCanWeHelp/YourGoals.vue";
import ForWomen from "./Slides/HowCanWeHelp/ForWomen.vue";
import YourDojo from "./Slides/HowCanWeHelp/YourDojo.vue";

export const useSamplePresentation = () => startPresentation(
{

    key: 'sample',
    title: 'Sample Presentation',
    password: 'gkr', 
    enableNextSlideIndicator: false,
    ratio: 4/3,
    isTabletMode: true,

    theme: {
        logo: '/logo-small.png',
        bgColorFrom: '#81141d',
        bgColorTo: '#ce202f',
        navColorFrom: '#ff273a',
        navColorTo: '#cc1f2e',
        nextButtonBackground: '#ffffff',
        nextButtonText: '#000000',
        triggerButtonBackground: '#10b981',
        triggerButtonText: '#ffffff'
    },

    sections: [

        // Introduction
        { 
            name: DefaultSections.Start, 
            title: 'Introduction',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Introduction }
            ],
            images: [

            ]
        },

        // Warm Greeting
        { 
            name: Map.Greeting, 
            title: 'Warm Greeting',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Greeting, hideNavigation: true }
            ],
            images: [

            ]
        },

        // Qualify Lead
        { 
            name: Map.QualifyLead, 
            title: 'Qualify Lead',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: LeadType }
            ],
            images: [

            ]
        },

        // Interest
        { 
            name: Map.Interest, 
            title: 'What can we do for you?',
            displayPageTitle: false, 
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Interest }
            ],
            images: [
                '/Interest/boy.jpg',
                '/Interest/girl.jpg',
                '/Interest/family.jpg',
            ]
        },

        // Interest Timeline
        { 
            name: Map.InterestTimeline, 
            title: 'How long have you been interested?',
            displayPageTitle: false,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: InterestTimeline }
            ],
            images: [
                '/InterestTimeline/competition.jpg',
                '/InterestTimeline/confidence.jpg',
                '/InterestTimeline/fitness.jpg',
                '/InterestTimeline/self-defence-female.jpg',
                '/InterestTimeline/self-defence-male.jpg',
                '/InterestTimeline/self-discipline.jpg',
            ]
        },

        // Dojo
        { 
            name: Map.ChooseDojo, 
            title: 'Choose Your Dojo',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: SelectDojo }
            ],
            images: [

            ]
        },

        // Offer
        { 
            name: Map.PresentOffer, 
            title: 'Special Offer',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: false,
            pages: [
                { title: '', component: Offer, hideNavigation: true }
            ],
            images: [

            ]
        },
        
        // Close
        { 
            name: Map.Close, 
            title: 'Thank You For Your Time',
            displayPageTitle: true,
            isAppendix: false,
            hasTitlePage: false,
            isHidden: true,
            pages: [
                { title: '', component: Close, hideNavigation: true }
            ],
            images: [

            ]
        },

        // HIDDEN - SEND INFORMATION EMAIL
        { 
            name: Map.OfferInformationEmail, 
            title: 'Send Information Email',
            displayPageTitle: false,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: OfferInformationEmail, hideNavigation: true }
            ],
            images: [

            ]
        },

        // FAMILY TRAINING
        { 
            name: Map.FamilyTraining, 
            title: 'Family Training',
            displayPageTitle: true,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: FamilyTraining, hideNavigation: true }
            ],
            images: [
            ]
        },

        // HOW CAN WE HELP
        { 
            name: Map.HowCanWeHelp, 
            title: 'How Can We Help',
            displayPageTitle: false,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: HowCanWeHelp }
            ],
            images: [
            ]
        },

        // YOUR GOALS
        { 
            name: Map.YourGoals, 
            title: 'Your Goals',
            displayPageTitle: true,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: YourGoals }
            ],
            images: [
                '/YourGoal/adult.jpg',
                '/YourGoal/boy-15s-preview.jpg',
                '/YourGoal/bullying.jpg',
                '/YourGoal/child.jpg',
                '/YourGoal/competition.jpg',
                '/YourGoal/confidence.jpg',
                '/YourGoal/family-preview.jpg',
                '/YourGoal/female-adult.jpg',
                '/YourGoal/general-preview.jpg',
                '/YourGoal/girl-15s-preview.jpg',
                '/YourGoal/male-adult.jpg',
                '/YourGoal/self-confidence-preview.jpg',
                '/YourGoal/self-defence-preview.jpg',
                '/YourGoal/self-discipline.jpg',
                '/YourGoal/teenager.jpg',
                '/YourGoal/why-join-gkr-adult-preview.jpg',
                '/YourGoal/why-join-gkr-child-preview.jpg',
                '/YourGoal/why-join-gkr-teenager-preview.jpg',
            ]
        },

        // FOR WOMEN
        { 
            name: Map.ForWomen, 
            title: 'For Women',
            displayPageTitle: true,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: ForWomen }
            ],
            images: [
            ]
        },

        // YOUR DOJO
        { 
            name: Map.YourDojo, 
            title: 'Your Dojo',
            displayPageTitle: true,
            isAppendix: true,
            isHidden: true,
            hasTitlePage: false,
            pages: [
                { title: '', component: YourDojo }
            ],
            images: [
            ]
        },

    ]

})
